<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/emp/qualification/page" getKey="rows" :columns="columns">
      <!-- 左侧按钮插槽 -->
      <template #buttonsL>
        <el-button size="mini" @click="yt.showEditDialog('xinzeng', null, '20%')" type="primary" v-if="utils.checkPower('web_employment_management_employee_create')">
          {{ $t('xinzeng') }}
        </el-button>
      </template>
      <template #caozuo="scope">
        <el-button size="mini" @click="yt.showEditDialog('bianji', scope.row, 'w1')" type="text">
          {{ $t('bianji') }}
        </el-button>
      </template>
    </yi_curd_table>

    <el-dialog :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" width="20%" :close-on-click-modal="false" append-to-body="append-to-body">
      <template v-if="yt.editObj.action == 'xinzeng'">
        <el-form ref="form" label-width="auto" size="mini">
          <el-form-item label="资质">
            <el-select v-model="form.qualificationId" placeholder="请选择资质" style="width: 80%;">
              <el-option v-for="item in qualificationList" :key="item.id" :label="item.qualName" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="授予时间">
            <el-date-picker v-model="form.authTime" type="datetime" placeholder="选择日期时间" style="width: 80%;"></el-date-picker>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="close">{{ $t('quxiao') }}</el-button>
          <el-button size="mini" :loading="yt.editObj.loading" @click="saveData()" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>

      <template v-if="yt.editObj.action == 'bianji'">
        <el-form ref="form" label-width="auto" size="mini">
          <el-form-item label="资质">
            <el-select v-model="yt.editObj.qualificationId" placeholder="请选择资质" style="width: 80%;">
              <el-option v-for="item in qualificationList" :key="item.id" :label="item.qualName" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="授予时间">
            <el-date-picker v-model="yt.editObj.authTime" type="datetime" placeholder="选择日期时间" style="width: 80%;"></el-date-picker>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="close">{{ $t('quxiao') }}</el-button>
          <el-button size="mini" :loading="yt.editObj.loading" @click="update()" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'qualification_table',
  props: {
    employeeId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      form: {
        empId: this.employeeId
      },
      columns: [
        {
          label: 'zizhibianhao',
          prop: 'qualification.qualNo'
        },
        {
          label: 'zizhimingcheng',
          prop: 'qualification.qualName'
        },
        {
          label: '授予时间',
          prop: 'authTime',
          type: 'time'
        },
        {
          label: 'caozuo',
          type: 'slot',
          width: 250,
          fixed: 'right'
        }
      ],
      qualificationList: []
    };
  },
  created() {
    setTimeout(() => {
      this.yt.conditions.empId = this.employeeId;
      this.$refs.yt.get(1);
      //查询资质
      this.http.get('/web/qualification/page', { params: { pageSize: 10000 } }).then(res => {
        this.qualificationList = res.data.rows;
      });
    }, 300);
  },
  methods: {
    saveData() {
      this.http
        .post('/web/emp/qualification/create', this.form)
        .then(res => {
          this.utils.successMessage(this.$t('success'));
          this.yt.isShowEditDialog = false;
          this.form = JSON.parse(JSON.stringify({}));
          this.yt.get(1);
        })
        .catch(error => {
          this.$message.error(this.$t(error));
        });
    },

    update() {
      this.http
        .post('/web/emp/qualification/update', this.yt.editObj)
        .then(res => {
          this.utils.successMessage(this.$t('success'));
          this.yt.isShowEditDialog = false;
          this.form = JSON.parse(JSON.stringify({}));
          this.yt.get(1);
        })
        .catch(error => {
          this.$message.error(this.$t(error));
        });
    },
    close() {
      this.yt.isShowEditDialog = false;
      this.form = {};
    }
  }
};
</script>

<style scoped lang="scss"></style>
